import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class ChangePasswordHandler {
    constructor({changePasswordCallback,}) {
        this.form = document.querySelector('#form-change-password');
        if (!this.form) {
            return;
        }
        this.formValidator = new FormValidator(this.form, {
            customValidators: {
                'checkPassword': (input) => this.checkPasswordRepeated(input),
                'sizePassword': (input) => this.checkSizePassword(input)
            }
        });
        this.changePasswordCallback = changePasswordCallback;
        this.eventDelegation();
    };

    eventDelegation() {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.formValidator.validateForm()) {
                const response = await this.changePasswordCallback();
                if (!response.code || !response.message) return;
                if (response.code == 400) {
                    const errorMessage = document.querySelector("#newPasswordMessage");
                    const input = document.querySelector("#newPassword");
                    input.classList.add('border-error');
                    errorMessage.classList.remove('color-secondary-dark');
                    errorMessage.classList.add('color-danger');
                } else {
                    var containerMessage = document.querySelector('[name="response-container-change-password"]');
                    var footerContainer = document.querySelector('#response-container-change-password-footer');
                    var title = containerMessage.querySelector('#message-container-title');
                    var message = containerMessage.querySelector('#message-container-text');
                    var button = containerMessage.querySelector('#message-container-button');
                    containerMessage.classList.remove('hidden');
                    footerContainer.style.display = 'none';
                    this.form.style.display = 'none';
                    if (response.code != 403) {
                        title.innerHTML = response.title;
                        message.innerHTML = response.message;
                        if (response.button) {
                            button.innerHTML = response.button;
                            button.setAttribute('href', response.url);
                        } else {
                            button.style.display = 'none';
                        }
                    }
                }
            }
        });
    }

    checkPasswordRepeated(input) {
        const newPassword = document.querySelector('#newPassword');
        const nameInput = input.id;
        const errorMessage = document.querySelector("#" + nameInput + "Message");
        if (newPassword && newPassword.value === input.value) {
            errorMessage.style.display = "none";
        } else {
            errorMessage.style.display = "block";
        }

        return newPassword && newPassword.value === input.value;
    }

    checkSizePassword(input) {
        const nameInput = input.id;
        const errorMessage = document.querySelector("#" + nameInput + "Message");
        if (input.value.length >= 6) {
            errorMessage.classList.remove('color-danger');
            errorMessage.classList.add('color-secondary-dark');
        } else {
            errorMessage.classList.remove('color-secondary-dark');
            errorMessage.classList.add('color-danger');
        }
        return input.value.length >= 6;
    }

}
